import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import { parseInt } from "lodash";


export default {
    
    getAll,
    editData,
    getEstatesByGroupID,
    getDailyAttendance
    
};

async function getAll(){
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function editData(data) {
    data.groupName = data.groupName.trim();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/Group/UpdateGroup', null, data);
    return response;
}


async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + parseInt(id));
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDailyAttendance(data) {
        var attendance = {
        operationalEntityID : parseInt(data.estate),
        createdDate : (data.date),
      
    }
    var response = await CommonPost('/api/DailyAttendance/GetDailyAttendance', null, attendance);
    return response.data;
    
}


